export enum MapPanelStatus {
  OPENED = "opened",
  CLOSED = "closed",
}
